<div class="d-flex flex-column gap-1 px-3 py-2">

  <!-- Name row -->
  <div class="d-flex align-items-center gap-2">
    <lib-color-swatch-picker
      [color]="object().color"
      [ariaLabel]="'Change color for ' + object().name"
      (colorApply)="colorChanged.emit($event)" />

    <mat-form-field appearance="fill" subscriptSizing="dynamic" class="name-field flex-fill">
      <input matInput
             [value]="object().name"
             [disabled]="disabled()"
             [attr.aria-label]="'Edit name for ' + object().name"
             (change)="onNameChange($event)" />
    </mat-form-field>

    <button matIconButton
            type="button"
            [attr.aria-label]="'Remove ' + object().name"
            [disabled]="disabled()"
            (click)="removed.emit(object().name)">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Threshold slider -->
  <div class="d-flex flex-column">
    <span class="mat-font-label-sm">
      Similarity threshold
    </span>
    <div class="d-flex align-items-center gap-2">
      <mat-slider class="flex-fill" min="0.00" max="0.99" step="0.01" [disabled]="disabled()">
        <input matSliderThumb
               [value]="object().threshold"
               (valueChange)="thresholdChanged.emit($event)"
               [attr.aria-label]="'Similarity threshold for ' + object().name" />
      </mat-slider>
      <span class="mat-font-label-md text-end">
        {{ object().threshold | number:'1.2-2' }}
      </span>
    </div>
  </div>


</div>
